import React from "react"
import { Grid, Box } from "@material-ui/core"
import styles from "./cardcontainer.module.scss"
import MouthBackground from "components/MouthBackground/MouthBackground"

interface Props {
  children: JSX.Element,
  loading: boolean,
  error: boolean
}

const CardContainer = (props: Props) => {
  const { loading, error } = props;

  let bodyContent = <div className={styles.loadingPlaceholder} />
  if (error) {
    bodyContent = <ErrorContent />
  } else if (!loading) {
    bodyContent = props.children;
  }
  return (
    <>
      <MouthBackground />
      <Grid
        alignItems='center'
        justify='center'
        container
        direction='column'
        className={styles.grid}
      >
        <Box className={styles.rootCard}>
          {bodyContent}
        </Box>
      </Grid>
    </>
  )
}

const ErrorContent = () => {
  return (
    <Box className={styles.errorContent}>
      <img
        className={styles.errorIcon}
        src={require("../../resources/error.svg")}
      />
      <p className={styles.errorText}>Couldn't find that jam...</p>
    </Box>
  )
}

export default CardContainer
